import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unreadCount: 0,
  notifications: [],
  pagination: { page: 1, total: 0 },
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setUnreadCount: (state, { payload }) => {
      state.unreadCount = payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    setNotifications: (state, { payload }) => {
      state.notifications = payload.notifications;
      state.pagination.total = payload.total;
    },
    setPaginationPage: (state, { payload }) => {
      state.pagination.page = payload;
    },
    prependNotification: (state, { payload }) => {
      if (state.pagination.page === 1) {
        state.notifications = [payload, ...state.notifications];
        state.pagination.total += 1;
      }
    },
  },
});

export const {
  setUnreadCount,
  incrementUnreadCount,
  setNotifications,
  setPaginationPage,
  prependNotification,
} = notificationSlice.actions;
